import { createContext, useContext, useState, useEffect } from 'react';
import ServicePlanAPI from '~/api/servicePlanApi';

const PlanFeatureContext = createContext();

export function PlanFeatureProvider({ children }) {
    const [planFeature, setPlanFeature] = useState({});

    useEffect(() => {
        ServicePlanAPI.getPlanFeatureByUser()
            .then((res) =>
            {
                setPlanFeature(res.data)
            })
            .catch(err => console.error("Failed to load plan features", err));
    }, []);

    return (
        <PlanFeatureContext.Provider value={{ planFeature }}>
            {children}
        </PlanFeatureContext.Provider>
    );
}

export const usePlanFeature = () => useContext(PlanFeatureContext);
